<template>
  <div>
    <!-- <div
      class="alert alert-danger alert-dismissable"
      style="z-index:1200!important"
      v-if="$store.state.errors != ''"
    >
      <a
        aria-hidden="true"
        data-dismiss="alert"
        class="close"
        href="javascript:void(0)"
        @click="$store.state.errors = ''"
        >×</a
      >
      <h4><i class="icon fa fa-check"></i> {{ Interval() }}</h4>
      {{ $store.state.errors }}
    </div> -->
    <!-- error alert start -->
    <div
      :class="
        $store.state.errors != ''
          ? 'alert alert-danger text-center p-1 notifications active'
          : ''
      "
      v-if="$store.state.errors != ''"
    >
      <button
        type="button"
        aria-hidden="true"
        class="close"
        @click="$store.state.errors = ''"
      >
        <b-icon font-scale="2" icon="x"></b-icon>
      </button>
      <h4>
        <i class="fas fa-exclamation-triangle"></i>&nbsp;
         {{ Interval() }}
      </h4>
      <p class="text-center">{{ $store.state.errors }}</p>
    </div>
    <!-- error alert end -->
    <router-view />
  </div>
</template>
<script>
export default {
  methods: {
    Interval() {
      setTimeout(() => {
        this.$store.state.errors = "";
      }, 3000);
    }
  }
};
</script>
<style scoped>
  .notifications {
    z-index: 9999;
    position: absolute;
    top: 0%;
    left: 15%;
    width: 75%;
  }
</style>